<template>
  <div class="search">
    <div class="copyrightManageBox">
      <Row @keydown.enter.native="handleSearch" style="padding-top:20px">
        <Form ref="formList" :model="formList" inline :label-width="100" class="search-form">
            <Form-item label="运营公司列表" prop="wemediaName">
                <Select v-model="formList.wemediaName" placeholder="请选择" clearable style="width: 200px" @on-change="changeWemedisId">
                  <Option v-for="(item, i) in wemediaManageListArr" :key="i" :value="item.id">
                    {{item.mediaName}}</Option>
                </Select>
            </Form-item>
            <Form-item label="授权状态" prop="authorizeStatus">
                <Select v-model="formList.authorizeStatus" placeholder="请选择" clearable style="width: 200px" @on-change="authorizeStatusCheck">
                  <Option v-for="(item, i) in copyrightAuthType" :key="i" :value="item.value">
                    {{item.title}}</Option>
                </Select>
            </Form-item>
            <!-- <Form-item label="排他输入" prop="title">
                <Input type="text" v-model="formList.title" placeholder="请输入排他输入" clearable style="width: 200px"/>
            </Form-item> -->
            <Form-item label="授权时长" prop="cooperationPeriod">
                <Select v-model="formList.cooperationPeriod" placeholder="请选择" clearable style="width: 200px">
                  <Option v-for="(item, i) in cooperationDurationType" :key="i" :value="item.value">{{item.title}}</Option>
                </Select>
            </Form-item>
            <Form-item label="授权开始时间" prop="cooperationStartTime">
                <DatePicker type="date" v-model="formList.cooperationStartTime" style="width:100%"></DatePicker>
            </Form-item>
        </Form>
      </Row>
    </div>
    <Row>
      <Col>
        <Card>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="copyrightAuthorizeDetailArr" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Row class="operation" style="text-align:right;margin-top:30px;">
        <Button @click="authorizeSubmit" type="primary">授权</Button>
        <Button @click="cansleAuthorize" style="margin:0 20px;">取消</Button>
      </Row>
  </div>
</template>

<script>

import {copyrightAuthorizeDetail,getCopyrightAuthorizeList,copyrightManageDelect,wemediaManageList,wemediaAccountManageList,copyrightAuthorizeSave,getAllwemediaAccountManageList} from "@/api/index";
export default {
  name: "authorize_list",
  components: {
  },
  data() {
    return {
      titleInfo:"",
      dataList:[],
      dataId:"",
      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        // sort: "createTime", // 默认排序字段
        // order: "desc", // 默认排序方式
        cooperationStartTime: "", // 起始时间
        cooperationEndTime: "" ,// 终止时间
        title:"",
        authorizeStatus:"",
        releaseDate:"",
        // authOperated:""
      },
      selectDate: null,
        formList: { 
        wemediaName:"",
        authorizeStatus:"",
        cooperationPeriod:"",
        cooperationStartTime:""
      },
      copyrightVendorNames:[],
      // 表单验证规则
      formValidate: {
      },
      dictTime:this.$store.state.dict.cooperationDurationType,
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "剧名",
          key: "title",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "类型",
          key: "copyrightAuthType",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "集数",
          key: "episodeNum",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "时长",
          key: "duration",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "上映时间",
          key: "releaseDate",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "是否已转授权运营",
          key: "copyrightStatus",
          minWidth: 120,
          sortable: false,
          render: (h, params) => {
            if (params.row.copyrightStatus == '1') {
              return h("div", [
                h(
                  "span",
                    "已转授权运营"
                  )
              ]);
            }else if (params.row.copyrightStatus == '0') {
              return h("div", [
                h(
                  "span",
                    "未转授权运营"
                  )
              ]);
            }
          }
        },
        {
          title: "拥有权利",
          key: "copyrightAuthType",
          minWidth: 120,
          sortable: false,
          render: (h, params) => {
            if (params.row.copyrightAuthType == 'ip_auth_exclusive') {
              return h("div", [
                h(
                  "span",
                    "独家"
                  )
              ]);
            }else if (params.row.copyrightAuthType == 'ip_auth_not_exclusive') {
              return h("div", [
                h(
                  "span",
                    "非独"
                  )
              ]);
            }else if (params.row.copyrightAuthType == 'ip_auth_public') {
              return h("div", [
                h(
                  "span",
                    "公版"
                  )
              ]);
            }else if (params.row.copyrightAuthType == 'ip_auth_exclusive_list') {
              return h("div", [
                h(
                  "span",
                    "排他独家"
                  )
              ]);
            }
          }
        },
        {
          title: "授权账号",
          key: "authOperated",
          minWidth: 280,
          sortable: false,
          render: (h, params) => {
            console.log(params)
            var wemediaManageAccountArrs = this.wemediaManageAccountArr;
            return h('div',[
              h(
                'Select',
                {
                  attrs:{
                    ref:"resetSelect"
                  },
                  props:{
                    multiple:true
                  },
                  on:{
                    'on-change':(event) => {
                        console.log(params.row.id)
                        this.copyrightAuthorizeDetailArr[params.index].wemediaAccountId = event;
                    }
                  }
                },
                wemediaManageAccountArrs.map(function(item){
                  return [h(
                    "Option",
                      {
                        props:{
                           value: item.id,
                           key: item.id
                        }
                      },item.accountName
                  )]
                })
              )
            ])
          }
        },
        // {
        //   title: "操作",
        //   key: "action",
        //   align: "center",
        //   width: 120,
        //   fixed: "right",
        //   render: (h, params) => {
        //     return h("div", [
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "error",
        //             size: "small",
        //             icon: "md-trash"
        //           },
        //           on: {
        //             click: () => {
        //               this.remove(params.row);
        //             }
        //           }
        //         },
        //         "删除"
        //       )
        //     ]);
        //   }
        // },
      ],
      data: [], // 表单数据
      total: 0, // 表单数据总数
      label:'',
      value:'',
      wemediaManageId:"",
      authorizeStatusValue:"",
      wemediaManageListArr:[],
      wemediaManageDetailArr:[],
      wemediaManageAccountArr:[],
      copyrightAuthType:this.$store.state.dict.copyrightAuthType,
      cooperationDurationType:this.$store.state.dict.cooperationDurationType,
    };
  },
  created(){
    //自媒体账号管理列表 
      this.wemediaAccountManageList()
  },

  methods: {
    init() {
      if (localStorage.cachePage) {
           this.$store.state.app.cachePage.length = 0;
        }
      //自媒体管理列表  运营公司列表、
      this.$nextTick(()=>{
        //授权管理详情
        this.copyrightAuthorizeDetail()
        this.wemediaManageList()
      })
      // this.getCopyrightAuthorizeList()
    },
    cansleAuthorize(){
      this.$router.push({
        name: "authorize-manage",//详情页面
      });
    },
    authorizeSubmit(){
      console.log(this.$refs.resetSelect)
      if(this.authorizeStatusValue==""){
        this.$Message.error("请选择授权状态");
        return false
      }
      if(this.formList.cooperationPeriod==""){
        this.$Message.error("请选择授权时长");
        return false
      }
      if(this.formList.cooperationStartTime != ""){
        var d = new Date(this.formList.cooperationStartTime);
        var resDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        this.formList.cooperationStartTime = resDate
      }else{
        this.$Message.error("请选择授权开始时间");
        return false
      }
      let dataList = [];
      for(let i in this.copyrightAuthorizeDetailArr){
        if(this.copyrightAuthorizeDetailArr[i].wemediaAccountId){
          dataList.push({
            copyrightId:this.copyrightAuthorizeDetailArr[i].id,
            wemediaAccountIds:(this.copyrightAuthorizeDetailArr[i].wemediaAccountId).join(",")
          })
        }
      }
      let data = {
        // wemediaId:this.wemediaManageId,
        authorizeType:this.authorizeStatusValue,
        cooperationPeriod:this.formList.cooperationPeriod,
        authorizeStartDate:this.formList.cooperationStartTime,
        list:dataList
      }
      console.log(data)
      copyrightAuthorizeSave(JSON.stringify(data)).then(res=>{
        if(res.success){
          this.$refs.formList.resetFields();
          console.log(this.$refs.table)
          console.log(this.$refs.resetSelect)
          // this.$refs.resetSelect.clearSingleSelect();
          this.$Message.success("授权成功");
          this.$store.commit("removeTag", "authorize_list");
           localStorage.pageOpenedList = JSON.stringify(
              this.$store.state.app.pageOpenedList
            );
          this.$router.push({
            name: "authorize-manage",
          });
        }else{
          this.$Message.error(res.message)
        }
      
      })
      
    },
    copyrightAuthorizeDetail(){
      copyrightAuthorizeDetail({ids:this.$route.query.id}).then(res=>{
        if(res.success){
          this.copyrightAuthorizeDetailArr = res.result
          this.$set(this.copyrightAuthorizeDetailArr,this.copyrightAuthorizeDetailArr,res.result)
        }
        this.loading = false;
      })
    },
    wemediaManageList(){
      wemediaManageList().then(res=>{
        if(res.success){
          console.log(res)
          this.wemediaManageListArr = res.result.records;
        }
      })
    },
    authorizeStatusCheck(data){
      this.authorizeStatusValue = data;
    },
    changeWemedisId(data){
      if(data){
        this.wemediaManageId = data;
        this.wemediaAccountManageList()
      }
    },
    wemediaAccountManageList(row){
      let data={}
      if(this.wemediaManageId==""){
        data = {wemediaId:this.wemediaManageId}
      }else{
        data = {wemediaId:this.wemediaManageId}
        // data = {wemediaId:this.wemediaManageId,copyrightId:row.id}
      }
      getAllwemediaAccountManageList(data).then(res=>{
        if(res.success){
          console.log(res)
          this.wemediaManageAccountArr = res.result;
        }
        this.loading = false;
      })
    },
    getCopyrightAuthorizeList(){
        getCopyrightAuthorizeList(this.searchForm).then(res=>{
        if(res.success){
          this.dataList = res.result.records;
          this.total = res.result.total;
        }
        this.total = this.dataList.length;
        this.loading = false;
      })
    },
    changeId(item){
      console.log(item)
      this.value = item.value
      this.label = item.label
    },
    uploadFile(event){
      console.log(event.target.files[0].size)
      let maxSize = 1024 * 1024 * 2
      if(event.target.files[0].size > maxSize){
        alert('上传文件过大！最大只能上传2M的文件')
        return false
      }
      this.form.importFile = event.target.files[0]
    },
    sendDetail(v) {
      let query = { id: v.id };
      this.$router.push({
        name: "copyright_manage_detail",//详情页面
        query: query
      });
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getCopyrightAuthorizeList();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getCopyrightAuthorizeList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getCopyrightAuthorizeList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.selectDate = null;
      this.searchForm.cooperationStartTime = "";
      this.searchForm.cooperationEndTime = "";
      // 重新加载数据
      this.getCopyrightAuthorizeList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getCopyrightAuthorizeList();
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.cooperationStartTime = v[0];
        this.searchForm.cooperationEndTime = v[1];
      }
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    remove(v) {
      this.$Modal.confirm({
        title: "确认删除",
        // 记得确认修改此处
        content: "您确认要删除 " + v.title + " ?",
        loading: true,
        onOk: () => {
          // 删除
          let len = this.copyrightAuthorizeDetailArr.length;
          for(let  i in this.copyrightAuthorizeDetailArr){
            if(this.copyrightAuthorizeDetailArr[i].id == v.id){
              this.$Modal.remove();
              this.copyrightAuthorizeDetailArr.splice(i, 1)
            }
          }
        }
      });
    },
    delAll() {
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
          copyrightManageDelect(ids).then(res => {
            this.$Modal.remove();
            if (res.success) {
              this.$Message.success("操作成功");
              this.getCopyrightAuthorizeList();
            }
          });
        }
      });
    },
  },
  mounted() {
    this.$nextTick(()=>{
      this.init();
    })
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
.copyrightManageBox{
    .ivu-row{
        line-height: 40px;
        .ivu-col{
            span:nth-of-type(1){
                width: 115px;
                display: inline-block;
                text-align: right;
            }
            span:nth-of-type(2){
                margin-left:15px;
            }
        }
    }
}
.ivu-card-body{
    .ivu-table-wrapper{
      overflow: inherit
    } 
    .ivu-table{
      overflow: inherit
    }
}
</style>